import React from "react"
import parse from "html-react-parser"

import * as S from "./how-copia-works.styles"

const HowCopiaWorks = props => {
  const { title, description } = props
  return (
    <S.Section>
      <S.Wrapper>
        <S.Title>{title}</S.Title>
        <S.Description>{parse(description)}</S.Description>
      </S.Wrapper>
    </S.Section>
  )
}

export default HowCopiaWorks
